import React, { useState } from 'react';
import { usePermissionContext } from "../../contexts/permission-context";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// mui does not support a default TabPanel out of the box except in experimental lab package so create one from examples
import TabPanel from '../../components/TabPanel/TabPanel';

import PageHeader from "../../components/PageHeader/PageHeader";
import DocumentProcessStatusTabPanel from "./DocumentProcessStatusTabPanel";
import DocumentEnvisionProcessStatusTabPanel from "./DocumentEnvisionProcessStatusTabPanel";
import DocumentCoreTabPanel from './DocumentCoreTabPanel';
import DocumentReportTabPanel from './DocumentReportTabPanel';
import DocumentIngestionStatusTabPanel from './DocumentIngestionStatusTabPanel';
import DocumentIDPStatusTabPanel from './DocumentIDPStatusTabPanel';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import { assetsUseManageOptions, hasPermission } from '../../Utils/Common';

const Documents = () => {
  const { permissions } = usePermissionContext();
  const hasAssetsUsePermission = hasPermission(permissions, assetsUseManageOptions);

  const initialSnackbarState = {
    open: false,
    message: '',
    alertTitle: '',
    severity: 'info',
    hideDuration: 1000
  };

  const [notify, setNotify] = useState(
    initialSnackbarState
  );

  const [createEnvisionDocument, setCreateEnvisionDocument] = useState(false);

  // define names of tabs
  const tabs = [
    {
      label: 'Ingestion Status',
      value: 'ingestionStatus',
      component: <DocumentIngestionStatusTabPanel setNotify={setNotify} />
    },
    {
      label: 'IDP Status',
      value: 'idpStatus',
      component: <DocumentIDPStatusTabPanel setNotify={setNotify} />
    },
    {
      label: 'CSP Documents',
      value: 'processStatus',
      component: <DocumentProcessStatusTabPanel setNotify={setNotify} />
    },
    {
      label: 'Core Documents',
      value: 'coreDocuments',
      component: <DocumentCoreTabPanel setNotify={setNotify} />
    },
    {
      label: 'enVision Documents',
      value: 'envisionProcessStatus',
      component: <DocumentEnvisionProcessStatusTabPanel setNotify={setNotify} createEnvisionDocument={createEnvisionDocument} setOpenEnvisionDocument={setCreateEnvisionDocument} />
    },
    {
      label: 'Reports',
      value: 'reports',
      component: <DocumentReportTabPanel setNotify={setNotify} />
    }
  ];

  let selectedIndex = sessionStorage.getItem("document") !== null ? sessionStorage.getItem("document") : 0
  const [value, setValue] = useState(+selectedIndex);    // set to previous visited process status tab
  const [selectedTab, setSelectedTab] = useState(tabs[value].value);



  const handleChange = (event, newValue) => {
    sessionStorage.setItem("document", newValue)
    setSelectedTab(tabs[newValue].value);

    setValue(newValue);

    getPageHeader();       // needed??
  };


  // initially we needed different page headers. Requirement was changed. Technically we don't need this but leaving for now
  const getPageHeader = () => {
    switch (selectedTab) {
      case 'envisionProcessStatus':
        return (<PageHeader title='Documents' includeCreate={hasAssetsUsePermission} createTitle='Create enVision Document Process' onCreate={onCreateEnvisionProcess} />);
      // common page header on all tabs
      case 'coreDocuments':
      case 'reports':
      case 'processStatus':
      case 'ingestionStatus':
      case 'idpStatus':
      default:
        return (<PageHeader title='Documents' includeCreate={false} />);
    }
  };

  const onCreateEnvisionProcess = () => {
    // console.log("Create Envision Process button clicked");

    setCreateEnvisionDocument(true);
  };

  return (
    <>

      <AlertSnackbar
        notify={notify}
        setNotify={setNotify} />

      {getPageHeader()}

      <Tabs value={value} onChange={handleChange} aria-label="document tabs">
        {tabs.map((tab) => <Tab key={`${tab.value}-tab`} id={`${tab.value}-tab`} label={tab.label} sx={{ textTransform: 'none' }} />)}
      </Tabs>

      {tabs.map((tab, index) => <TabPanel key={`${tab.value}-panel`} id={`${tab.value}-panel`} value={value} index={index}>{tab.component}</TabPanel>)}

    </>
  );
}

export default Documents;
